import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=8eb8ab22&scoped=true"
import script from "./Documento.vue?vue&type=script&lang=js"
export * from "./Documento.vue?vue&type=script&lang=js"
import style0 from "./Documento.vue?vue&type=style&index=0&id=8eb8ab22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb8ab22",
  null
  
)

export default component.exports